import { type ReduxUser } from 'models';

export const canViewVideos = ({ viewer }: { viewer: ReduxUser }) => viewer.superadmin;
